import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DefaultBannerWrapper } from './DefaultBanner.styles';
import { CloseWrapper, Content } from '../UserNotificationBanner.styles';
import Icon from '../../../../Shared/Icons/Icons';

const DefaultBanner = props => {
  const { userNotification, dismissUserNotification } = props;
  const { theme, notificationData } = userNotification;

  const className = classnames({
    'is-info': theme === 'INFO',
    'is-warning': theme === 'WARNING',
    'is-error': theme === 'ERROR'
  });

  const content = notificationData.message;

  if (!content) return null;
  return (
    <DefaultBannerWrapper className={className}>
      <Content>{content}</Content>
      <CloseWrapper onClick={dismissUserNotification}>
        <Icon iconName="close" />
      </CloseWrapper>
    </DefaultBannerWrapper>
  );
};

DefaultBanner.propTypes = {
  userNotification: PropTypes.shape({
    notificationId: PropTypes.number.isRequired,
    recipientUserId: PropTypes.string.isRequired,
    notificationType: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    notificationData: PropTypes.shape({}).isRequired,
    rowLoadedDateTime: PropTypes.string.isRequired
  }).isRequired,
  dismissUserNotification: PropTypes.func.isRequired
};

export default DefaultBanner;
